import actionTypes from '../actionTypes';

export function setFirstTimeUser(payload) {
	return {
		type: actionTypes.SET_FIRST_TIME_USER,
		payload,
	};
}

export function saveFirstTimeUserStatus(payload) {
	return {
		type: actionTypes.SAVE_FIRST_TIME_USER_STATUS,
		payload,
	};
}

export function saveFirstTimeUserStatusSuccess() {
	return {
		type: actionTypes.SAVE_FIRST_TIME_USER_STATUS_SUCCESS,
	};
}

export function saveFirstTimeUserStatusFailure(payload) {
	return {
		type: actionTypes.SAVE_FIRST_TIME_USER_STATUS_FAILURE,
		payload,
	};
}

export function setPersona(payload) {
	return {
		type: actionTypes.SET_PERSONA,
		payload,
	};
}

export function changePersona(payload) {
	return {
		type: actionTypes.CHANGE_PERSONA,
		payload,
	};
}

export function isUPCSelected(payload) {
	return {
		type: actionTypes.SELECTED_UPC,
		payload,
	};
}

export function disabledsADAlert(payload) {
	return {
		type: actionTypes.DISABLE_DSADALERT,
		payload,
	};
}

export function disabledsADAlertSuccess(payload) {
	return {
		type: actionTypes.DISABLE_DSADALERT_SUCCESS,
		payload,
	};
}

export function disabledsADAlertFailure(payload) {
	return {
		type: actionTypes.DISABLE_DSADALERT_FAILURE,
		payload,
	};
}
